import React, { useState, useEffect } from "react";
import { ArrowBackIosSharp, ArrowForwardIosSharp, Favorite, Visibility } from "@material-ui/icons";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Spinner from "../Spinner";

const ListLayout = ({
    items: initialItems = [],
    isLoading,
    onFavorite,
    onItemSelect,
    children,
    selectedIndex,
    setSelectedIndex,
    hideOnFavorite = false,
}) => {
    const [sortType, setSortType] = useState("all");
    const [value, setValue] = useState("");
    const [customerList, setCustomerList] = useState(initialItems);
    const [tableItems, setTableItems] = useState(initialItems);
    const [isOpen, setIsOpen] = useState(false);

    // When initial items change update lists
    useEffect(() => {
        setCustomerList(initialItems);
        setTableItems(initialItems);
    }, [initialItems]);

    // Sorting functionality
    useEffect(() => {
        let sortedList = [...customerList];
        if (sortType === 'mostlyviewed') {
            sortedList.sort((a, b) => {
                if (a.numberofView !== b.numberofView) return b.numberofView - a.numberofView;
                return (a.customer || a.name)?.toLowerCase().localeCompare((b.customer || b.name)?.toLowerCase() || "");
            });
        } else if (sortType === 'favourite') {
            sortedList.sort((a, b) => {
                if (b.isFavourite !== a.isFavourite) return b.isFavourite - a.isFavourite;
                return (a.customer || a.name)?.toLowerCase().localeCompare((b.customer || b.name)?.toLowerCase() || "");
            });
        }
        // For "all", no sorting is applied
        if (JSON.stringify(sortedList) !== JSON.stringify(customerList)) {
            setCustomerList(sortedList);
            setTableItems(sortedList);
        }
    }, [sortType]);

    const handleSorting = (sortBy) => {
        setSortType(sortBy);
    };

    // Search functionality
    const filterData = (e) => {
        const searchVal = e.target.value;
        setValue(searchVal);
        if (searchVal !== "") {
            const filtered = customerList.filter((item) =>
                Object.keys(item).some(key =>
                    String(item[key]).toLowerCase().includes(searchVal.toLowerCase())
                )
            );
            setTableItems(filtered);
        } else {
            setTableItems(customerList);
        }
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="customerlist">
            <Container fluid>
                <Button variant="primary" className={`customer-button ${isOpen ? 'open' : ''}`} onClick={toggleSidebar}>
                    {isOpen ? (
                        <ArrowBackIosSharp style={{ width: '100%', minWidth: '10px' }} />
                    ) : (
                        <ArrowForwardIosSharp style={{ width: '100%', minWidth: '10px' }} />
                    )}
                </Button>
                <div className={`sidebar ${isOpen ? 'open' : ''}`} style={{ position: 'fixed' }}>
                    <div className="customerlist-leftsection">
                        <Row>
                            <Col sm={12} md={12} lg={7} xl={8}>
                                <div className="customer-search-form">
                                    <form>
                                        <input
                                            placeholder="Search"
                                            aria-label="Search"
                                            type="search"
                                            className="me-2 form-control"
                                            onChange={filterData}
                                            value={value}
                                        />
                                        <span>
                                            <i className="fa fa-search" aria-hidden="true"></i>
                                        </span>
                                    </form>
                                </div>
                            </Col>
                            <Col sm={12} md={12} lg={5} xl={4}>
                                <div className="customer-search-form">
                                    <Form.Group as={Col} controlId="formGridState">
                                        <Form.Select defaultValue="all" onChange={e => handleSorting(e.target.value)}>
                                            <option value="all">All</option>
                                            <option value="mostlyviewed">Mostly Viewed</option>
                                            <option value="favourite">Favourite</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                        <div className="list-of-customer">
                            {isLoading && <Spinner />}
                            {tableItems.map((data, index) => (
                                <div
                                    className={`customer_list_section ${selectedIndex === index ? "active" : ""}`}
                                    key={index}
                                    onClick={() => {
                                        setSelectedIndex(index);
                                        onItemSelect && onItemSelect(data);
                                    }}
                                >
                                    {data.companyName ? <div>{data.companyName}</div> : null}
                                    <div className="customer-list">
                                        <div className="account-number">{data.account_No}</div>
                                        <div className="customer-name">{data.customer || data.name}</div>
                                    </div>
                                    <div className="sort_icon">
                                        <a className="view_count">
                                            <Visibility />
                                            <span className="badge">{data.numberofView}</span>
                                        </a>
                                        {hideOnFavorite ? null : <a
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onFavorite && onFavorite(data.account_No);
                                            }}
                                            className={data.isFavourite ? "favorite active" : "favorite"}
                                        >
                                            <Favorite />
                                        </a>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div>
                    <div className="customer-detail">
                        {children}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default ListLayout;
